// src/components/common/Button/Button.jsx
import React from 'react';
import styles from './Button.module.css';

const Button = ({ children, onClick, type = 'button', variant = 'primary', className = '', size = 'normal', ...props }) => {
    return (
        <button
            type={type}
            className={`${styles.button} ${styles[variant]} ${styles['size--' + size]} ${className}`}
            onClick={onClick}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
